import React from 'react';
import I18n from '@/modules/i18n';

export const PASSWORD_POLICY_USER_TYPES = [
  { labelKey: 'admins', value: 'Admin' },
  { labelKey: 'teachers', value: 'Teacher' },
  { labelKey: 'coordinators', value: 'Coordinator' },
  { labelKey: 'students', value: 'Student' },
];

interface PasswordPolicyCheckboxesProps {
  disabled: boolean;
  idPrefix?: string;
  onUserTypeChange: (userType: string, checked: boolean) => void;
  selectedUserTypes: string[];
}

const PasswordPolicyCheckboxes = ({
  disabled,
  idPrefix = 'strict-password',
  onUserTypeChange,
  selectedUserTypes,
}: PasswordPolicyCheckboxesProps) => (
  <div className="tw-max-w-60 tw-grid tw-grid-cols-2 tw-gap-x-4 tw-gap-y-1">
    {PASSWORD_POLICY_USER_TYPES.map((userType) => {
      const checkboxId = `${idPrefix}-${userType.value.toLowerCase()}`;
      return (
        <label
          key={userType.value}
          className="tw-flex tw-items-center tw-cursor-pointer"
          htmlFor={checkboxId}
        >
          <input
            checked={selectedUserTypes.includes(userType.value)}
            className="tw-cursor-pointer"
            disabled={disabled}
            id={checkboxId}
            type="checkbox"
            onChange={e => onUserTypeChange(userType.value, e.target.checked)}
          />
          <span className="tw-text-sm">{I18n.t(userType.labelKey)}</span>
        </label>
      );
    })}
  </div>
);

export default PasswordPolicyCheckboxes;
